<template>
  <div class="quickscan-step3">
    <h1>Aanvraag quickscan</h1>
    <h2>Controle</h2>

    <quickscan-stepper :current-step="3" :loading="!loaded">
      <v-error-messages ref="errorMessages" :messages="this.errorMessages"></v-error-messages>

      <p>
        Controleer uw gegevens en klik op verzenden als de gegevens juist zijn. Een medewerker gaat uw verzoek
        tot aanvraag vervolgens beoordelen.
      </p>
      <p>
        Indien akkoord ontvangt u een uitgebreide vragenlijst voor het indienen van uw daadwerkelijke aanvraag.
      </p>

      <v-row dense>
        <v-col cols="3">Achternaam</v-col>
        <v-col cols="9">{{ applicant.name }}</v-col>
      </v-row>
      <v-row dense>
        <v-col cols="3">Adres</v-col>
        <v-col cols="9">{{ applicant.address }}</v-col>
      </v-row>
      <v-row dense>
        <v-col cols="3">Postcode</v-col>
        <v-col cols="9">{{ applicant.zipcode }}</v-col>
      </v-row>
      <v-row dense>
        <v-col cols="3">Plaatsnaam</v-col>
        <v-col cols="9">{{ applicant.city }}</v-col>
      </v-row>
      <v-row dense>
        <v-col cols="3">E-mailadres</v-col>
        <v-col cols="9">{{ applicant.email }}</v-col>
      </v-row>
      <v-row dense>
        <v-col cols="3">Telefoonnummer</v-col>
        <v-col cols="9">{{ applicant.phone }}</v-col>
      </v-row>

      <v-row>
        <v-col cols="3">Korte omschrijving</v-col>
        <v-col cols="9">{{ application.shortDescription }}</v-col>
      </v-row>

      <v-row>
        <v-col cols="12" md="9" offset-md="3">LET OP: als u de aanvraag kunt indienen is dit nog geen garantie op
          toekenning!
        </v-col
        >
      </v-row>
      <v-row>
        <v-col cols="3">Quickscan versie</v-col>
        <v-col cols="9">
          <v-radio-group :error="hasErrors('preferedVersion')" :error-messages="handleErrors('preferedVersion')" v-model="application.preferedVersion">
            <template v-slot:label>
              <div>Geef aan of u liever de <strong>papieren</strong> of de <strong>digitale</strong> versie van de
                aanvraag ontvangt<br/></div>
            </template>
            <v-radio value="digitaal">
              <template v-slot:label>
                <div>
                  <!--                        <v-icon>mdi-form-textbox-lock</v-icon>-->
                  <v-icon>mdi-keyboard-outline</v-icon>
                  Ik heb liever de <strong class="success--text">digitale</strong> versie
                </div>
              </template>
            </v-radio>
            <v-radio value="papier">
              <template v-slot:label>
                <div>
                  <v-icon>mdi-printer-outline</v-icon>
                  Ik heb liever de <strong class="success--text">papieren</strong> versie
                </div>
              </template>
            </v-radio>
          </v-radio-group>
        </v-col>
      </v-row>

      <v-row no-gutters>
        <v-col cols="12" md="9" offset-md="3">
          <v-checkbox :error="hasErrors('enteredTruthfully')" :error-messages="handleErrors('enteredTruthfully')"
                      v-model="application.enteredTruthfully"
                      label="Ik heb bovenstaande gegevens naar waarheid ingevuld."
          ></v-checkbox>
        </v-col>
      </v-row>

      <v-form>
        <v-row>
          <v-spacer></v-spacer>
          <v-col cols="auto">
            <v-btn @click="back" :loading="backBtnClicked" :disabled="submitting">Terug</v-btn>
          </v-col>
          <v-col cols="auto">
            <v-btn color="primary" @click="submit" :loading="submitBtnClicked" :disabled="submitting"
            >Verzenden
            </v-btn
            >
          </v-col>
        </v-row>
      </v-form>
    </quickscan-stepper>
  </div>
</template>

<script>
import {mapActions, mapGetters} from 'vuex';
import QuickscanStepper from '../components/QuickscanStepper';
import VErrorMessages from '@/components/VErrorMessages';

export default {
  name: 'quickscan-step3',
  components: {
    QuickscanStepper,
    VErrorMessages,
  },
  data: () => ({
    loaded: false,
    backBtnClicked: false,
    submitBtnClicked: false,
    submitting: false,

    errorMessages: [],
    applicant: {
      name: null,
      address: null,
      zipcode: null,
      city: null,
      email: null,
      phone: null,
    },
    application: {
      preferedVersion: null,
      shortDescription: null,
      enteredTruthfully: null,
    },
    errorDetails: {},
  }),
  computed: {
    ...mapGetters({vuex: 'step3'}),
  },
  created: function () {
    const that = this;
    this.quickscanStep3Load().then(function () {
      const applicant = that.vuex.applicant;
      const application = that.vuex.application;

      that.applicant.name = applicant.name;
      that.applicant.address = applicant.address;
      that.applicant.zipcode = applicant.zipcode;
      that.applicant.city = applicant.city;
      that.applicant.email = applicant.email;
      that.applicant.phone = applicant.phone;
      that.application.shortDescription = application.shortDescription;
      that.application.enteredTruthfully = application.enteredTruthfully;

      that.loaded = true;
    });
  },
  methods: {
    ...mapActions(['quickscanStep3Load', 'quickscanStep3Submit']),
    hasErrors(name) {
      return '' !== this.handleErrors(name);
    },
    handleErrors(name) {
      if (this.errorDetails[name] !== undefined) {
        let error = '';
        Object.entries(this.errorDetails[name]).forEach(entry => {
          const [errorType, value] = entry;
          error += " " + value;
        });
        return error;
      }
      return '';
    },
    getPayload: function () {
      return {
        data: {
          application: {
            enteredTruthfully: this.application.enteredTruthfully,
            preferedVersion: this.application.preferedVersion,
          },
        },
      };
    },
    back: function () {
      const that = this;
      this.backBtnClicked = true;
      this.submitting = true;
      this.errorMessages = [];

      if (!that.applicant.hasOtherContact)
        this.quickscanStep3Submit(this.getPayload()).finally(function () {
          that.$router.push({name: 'quickscan_step1'});
          that.backBtnClicked = false;
          that.submitting = false;
        });
      else
        this.quickscanStep3Submit(this.getPayload()).finally(function () {
          that.$router.push({name: 'quickscan_step2'});
          that.backBtnClicked = false;
          that.submitting = false;
        });
    },
    submit: function () {
      const that = this;
      this.submitBtnClicked = true;
      this.submitting = true;
      this.errorMessages = [];

      this.quickscanStep3Submit(this.getPayload())
          .then(function () {
            that.$router.push({name: 'quickscan_finish'});
          })
          .catch(function (error) {
            const response = error.response;
            if (response.data !== undefined && response.data.error !== undefined) {
              that.errorDetails = response.data.error.messages;
              that.errorMessages = ['Er ontbreken gegevens in deze stap'];
            } else {
              that.errorMessages = ['Onbekende fout!'];
            }
            that.$vuetify.goTo(that.$refs.errorMessages, {
              duration: 300,
              offset: 100,
              easing: 'easeInOutCubic',
            });
          })
          .finally(function () {
            that.submitBtnClicked = false;
            that.submitting = false;
          });
    },
  },
};
</script>
